import React, { useState, useEffect } from "react";
import { Menu } from "antd";
import slugify from "slugify";
import { reverse } from "named-urls";
import { Link, useLocation } from "react-router-dom";
import {
  BarChartOutlined,
  DollarOutlined,
  ArrowLeftOutlined,
  UserOutlined,
  UsergroupAddOutlined,
  ShoppingCartOutlined,
  DiffOutlined,
  DropboxOutlined,
  CarryOutOutlined,
  LineChartOutlined,
  KeyOutlined,
  DashboardOutlined,
} from "@ant-design/icons";
import routes from "../../../../routes";
import * as ACTIONS from "../../../constants/actions";
import { useAuth } from "../../../contexts/auth";
const { backOffice } = routes;

const Sidebar = () => {
  const location = useLocation();
  const [selectedItem, setSelectedItem] = useState();
  const auth = useAuth();
  const isCompanyAdmin = auth.isCompanyAdmin;

  const menuItems = [
    {
      label: "Dashboard",
      icon: <DashboardOutlined />,
      link: backOffice.dashboard_new.view,
      action: ACTIONS.BO_DASHBOARD_NEW,
    },

    {
      label: "Company Accounts",
      icon: <UserOutlined />,
      link: backOffice.companies.list,
      action: ACTIONS.ACCESS_COMPANY_LISTING,
    },
    {
      label: "User Accounts",
      icon: <UsergroupAddOutlined />,
      link: isCompanyAdmin
        ? reverse(backOffice.companies.details.users.list, {
            companyId: auth.loggedInUser.company._id,
          })
        : backOffice.users,
      action: ACTIONS.ACCESS_COMPANY_USER_LISTING,
    },
    {
      label: "Address Management",
      icon: <UserOutlined />,
      link: backOffice.addresses,
      action: ACTIONS.ACCESS_ADDRESS_SUMMARY,
    },
    {
      label: "Orders",
      icon: <ShoppingCartOutlined />,
      link: backOffice.orders.list,
      action: ACTIONS.ACCESS_ORDER_LISTING,
    },
    //Temporary Commented
    // {
    //   label: "Payment Reminders",
    //   icon: <DollarOutlined />,
    //   link: backOffice.orders.payments,
    //   action: ACTIONS.BO_ACCESS_PAYMENT_REMINDER,
    // },
    {
      label: "Master Catalog",
      icon: <BarChartOutlined />,
      link: backOffice.catalog.master,
      action: ACTIONS.ACCESS_MASTER_CATALOG,
    },
    {
      label: "Company Catalog",
      icon: <BarChartOutlined />,
      link: backOffice.catalog.companies,
      action: ACTIONS.ACCESS_COMPANY_CATALOG_LISTING,
    },
    {
      label: "Packages",
      icon: <DropboxOutlined />,
      link: backOffice.packages.list,
      action: ACTIONS.BO_ACCESS_PACKAGE_LISTING,
    },
    //Temporary Commented
    // {
    //   label: "Book Test",
    //   icon: <CarryOutOutlined />,
    //   link: backOffice.orders.new,
    //   action: ACTIONS.BO_ACCESS_BOOK_TEST,
    // },
    {
      label: "Lab Partners",
      icon: <DiffOutlined />,
      link: backOffice.labPartners.list,
      action: ACTIONS.ACCESS_LAB_LISTING,
    },
    {
      label: "Logistic Providers",
      icon: <DropboxOutlined />,
      link: backOffice.logisticPartners.list,
      action: ACTIONS.ACCESS_LOGISTICS_LISTING,
    },
    {
      label: "Consumer Portal",
      icon: <ArrowLeftOutlined />,
      link: routes.dashboard,
      action: ACTIONS.ACCESS_CONSUMER_PORTAL,
    },
    // {
    //   label: "Analytics",
    //   icon: <LineChartOutlined />,
    //   link: backOffice.analytics.view,
    //   action: ACTIONS.ACCESS_ANALYTICS,
    // },
    {
      label: "Samplers",
      icon: <UserOutlined />,
      link: backOffice.samplers.list,
      action: ACTIONS.BO_ACCESS_SAMPLER_LISTING,
    },
    //Temporary Commented
    // {
    //   label: "Agencies",
    //   icon: <UserOutlined />,
    //   link: backOffice.agencies.list,
    //   action: ACTIONS.ACCESS_ORDER_LISTING,
    // },
    {
      label: "Assets",
      icon: <KeyOutlined />,
      link: backOffice.assets.list,
      action: ACTIONS.BO_ACCESS_ASSETS_LISTING,
    },
  ];

  const authorisedMenuItems = menuItems.filter(
    (item) => auth.permissions.indexOf(item.action) !== -1
  );

  useEffect(() => {
    const selectedIndex = authorisedMenuItems
      .map((item) => item.link)
      .indexOf(location.pathname);
    if (selectedIndex !== -1) {
      const key = slugify(authorisedMenuItems[selectedIndex].label);
      setSelectedItem(key);
    }
  }, [authorisedMenuItems, location.pathname]);

  const handleSelected = ({ key }) => {
    // setSelectedItem(key);
  };

  return (
    <Menu
      theme="dark"
      mode="inline"
      selectedKeys={selectedItem}
      onSelect={handleSelected}
    >
      {authorisedMenuItems.map(({ icon, label, link }) => {
        return (
          <Menu.Item key={slugify(label)} icon={icon}>
            <Link to={link}>{label}</Link>
          </Menu.Item>
        );
      })}
    </Menu>
  );
};

export default Sidebar;
